module.exports = __webpack_public_path__ + "img/13.b80d6541.jpg";